import type { AiSpreadsheetCellKind, IAiSpreadsheetCell } from "./types";
import { AI_SPREADSHEET_CELL_KIND } from "./types";

const asCellKind = (
  value: string | null | undefined,
): AiSpreadsheetCellKind | undefined =>
  value === AI_SPREADSHEET_CELL_KIND.formula ||
  value === AI_SPREADSHEET_CELL_KIND.value
    ? value
    : undefined;

export const getRawInputKind = (rawInput: string): AiSpreadsheetCellKind =>
  rawInput.trimStart().startsWith("=")
    ? AI_SPREADSHEET_CELL_KIND.formula
    : AI_SPREADSHEET_CELL_KIND.value;

// Older workbook payloads may not include `kind`; preserve their historical
// leading-`=` inference while respecting explicit value cells that contain a
// literal formula-looking string.
export const getCellKind = (
  cell: Pick<IAiSpreadsheetCell, "kind" | "raw_input"> | null | undefined,
): AiSpreadsheetCellKind =>
  asCellKind(cell?.kind) ?? getRawInputKind(cell?.raw_input ?? "");

export const isFormulaCell = (
  cell: Pick<IAiSpreadsheetCell, "kind" | "raw_input">,
): boolean => getCellKind(cell) === AI_SPREADSHEET_CELL_KIND.formula;
